import { useCallback } from 'react';
import { useRequest } from '@Hooks';
import { API } from '@Services';
import { NominationMatchResult } from '@Types';

export const useGetNominationMatches = () => {
  const [fetch, response] = useRequest<NominationMatchResult>();

  const getNominationMatches = useCallback(
    (slug: string, nomineeGroupName: string) =>
      fetch(API.paths.nomination_form_possible_matches(slug), 'get', {
        params: { nominee_group_name: nomineeGroupName },
      }),
    [fetch],
  );

  return [getNominationMatches, response] as const;
};
